import { Box } from '@quintoandar-tokko/jopijs';
import RowName from '../../DashboardOverview/RowCards/components/RowName';
import ProgressBar from '../../DashboardOverview/RowCards/components/ProgressBar';
import ItemCount from '../../DashboardOverview/RowCards/components/ItemCount';
import PercentageValue from '../../DashboardOverview/RowCards/components/PercentageValue';
import styles from './inquiriesReceived.module.scss';
import WithoutCategoryTag from '../../DashboardOverview/RowCards/components/WithoutCategoryTag';

export default function InquiriesReceivedRow({
  name,
  percentage,
  count,
  withLabel = true,
  ...rest
}) {
  return (
    <Box className={styles.row} {...rest}>
      <Box className={styles.rowInnerWrapper}>
        {withLabel ? (
          <RowName text={name} />
        ) : (
          <WithoutCategoryTag text={name} />
        )}
        <ProgressBar percentage={percentage} />
        <ItemCount icon="icon-contactos" value={count} />
        <PercentageValue percentage={percentage} />
      </Box>
    </Box>
  );
}
